export default __webpack_public_path__ + "static/media/143.c8fd21b9.svg";